import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-layout__main gfu-layout__main--extranarrow _mb-6 _mt-6" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_project_navigation = _resolveComponent("project-navigation")
  const _component_project_updates = _resolveComponent("project-updates")

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { id: "navigation" }, null, -1 /* CACHED */)),
    _createVNode(_component_project_navigation, {
      items: $props.navigation.items
    }, null, 8 /* PROPS */, ["items"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_project_updates, {
        "show-user-context-filter": $props.showUserContextFilter,
        "allow-filter": $props.allowFilter
      }, null, 8 /* PROPS */, ["show-user-context-filter", "allow-filter"])
    ])
  ]))
}